// extracted by mini-css-extract-plugin
export default {"rolesOfRaccoons":"_6-FunctionalRole_rolesOfRaccoons__LArhF"};